import { MIN_NUTRITION_GENERATION_CALORIES } from "@fitness-app/data-models/ai/nutrition-input";
import { Form, InputNumber } from "antd";
import { useTranslation } from "react-i18next";

export function NutritionGenerationCaloriesField() {
  const { t } = useTranslation(["nutrition", "common"]);
  const generateEmptyTemplate = Form.useWatch("generateEmptyTemplate");
  return (
    <Form.Item
      name="targetCalories"
      dependencies={["generateEmptyTemplate"]}
      label={t<string>("mealPlanForm.targetCalories")}
      rules={[
        {
          required: true,
          message: t<string>("common:validationErrors.fieldIsRequired"),
        },
        ...(!generateEmptyTemplate
          ? [
              {
                type: "number" as const,
                min: MIN_NUTRITION_GENERATION_CALORIES,
                message: `Cel dzienny musi wynosić co najmniej ${MIN_NUTRITION_GENERATION_CALORIES} kcal`,
              },
            ]
          : []),
      ]}
    >
      <InputNumber
        // Enforce the generation minimum in Form.Item: InputNumber otherwise
        // keeps the previous valid form value when the user types below min.
        min={generateEmptyTemplate ? 0 : undefined}
        max={5000}
        precision={0}
        changeOnBlur={false}
      />
    </Form.Item>
  );
}
